import { CardData } from '../../../../types';
import SliderInput from '../SliderInput';

interface ImageConfigModalProps {
    cardNum: 1 | 2 | null;
    data: CardData | null;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: any) => void;
    onClose: () => void;
}

export const ImageConfigModal = ({ cardNum, data, onChange, onClose }: ImageConfigModalProps) => {
    if (!cardNum || !data) return null;

    const handleChange = (field: keyof CardData, value: any) => {
        onChange(cardNum, field, value);
    };

    return (
        <div className="side-by-side-modal-overlay" onClick={onClose}>
            <div className="modal-content image-config-modal" onClick={(e) => e.stopPropagation()}>
                <ModalHeader onClose={onClose} />

                <div className="modal-body">
                    <ImagePreview
                        image={data.image}
                        imageRadius={data.imageRadius}
                        overlayOpacity={data.overlayOpacity}
                        objectFit={data.objectFit}
                    />

                    <div className="input-group">
                        <label>Alt Text</label>
                        <input
                            type="text"
                            value={data.altText}
                            onChange={(e) => handleChange('altText', e.target.value)}
                            placeholder="Describe the image (SEO)"
                            className="form-control"
                        />
                    </div>

                    <SliderInput
                        label="Image Overlay Opacity"
                        value={data.overlayOpacity}
                        min={0}
                        max={100}
                        unit="%"
                        onChange={(val) => handleChange('overlayOpacity', val)}
                    />

                    <SliderInput
                        label="Image Radius"
                        value={data.imageRadius}
                        min={0}
                        max={50}
                        unit="px"
                        onChange={(val) => handleChange('imageRadius', val)}
                    />

                    <div className="select-group">
                        <label>Object Fit</label>
                        <select
                            value={data.objectFit}
                            onChange={(e) => handleChange('objectFit', e.target.value)}
                            className="form-control"
                        >
                            <option value="cover">Cover (Fill Area)</option>
                            <option value="contain">Contain (Fit Inside)</option>
                        </select>
                    </div>
                </div>

                <ModalFooter onClose={onClose} />
            </div>
        </div>
    );
};


const ModalHeader = ({ onClose }: { onClose: () => void }) => (
    <div className="modal-header">
        <h3>More Configuration</h3>
        <button className="close-btn" onClick={onClose}>
            ×
        </button>
    </div>
);

const ModalFooter = ({ onClose }: { onClose: () => void }) => (
    <div className="modal-footer">
        <button className="done-btn" onClick={onClose}>
            Done
        </button>
    </div>
);

interface ImagePreviewProps {
    image: string;
    imageRadius: number;
    overlayOpacity: number;
    objectFit: 'cover' | 'contain';
}

const ImagePreview = ({ image, imageRadius, overlayOpacity, objectFit }: ImagePreviewProps) => (
    <div className="preview-section">
        <h5>Preview</h5>
        <div
            className="image-preview-large"
            style={{
                '--preview-radius': `${imageRadius}px`,
                '--preview-fit': objectFit,
                '--preview-opacity': overlayOpacity / 100
            } as React.CSSProperties}
        >
            {image ? (
                <img src={image} alt="Preview" />
            ) : (
                <div className="preview-placeholder-large" />
            )}
            <div className="image-overlay" />
        </div>
    </div>
);
